import {Errors} from "../errors";

let commandsIdCounter = 0;

export function getNextCommandId() {
    return ++commandsIdCounter;
}

export class BaseCommandMessage {
    id: number = getNextCommandId();

    constructor(readonly cmd: string) {
    }
}

export class BaseResponseMessage extends BaseCommandMessage {
    constructor(override readonly cmd: string, override readonly id: number, readonly success: boolean) {
        super(cmd);
        this.id = id;
    }
}

export class ErrorResponseMessage extends BaseResponseMessage {
    constructor(override readonly cmd: string, override readonly id: number, readonly error: Errors) {
        super(cmd, id, false);
    }
}
